/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>方案设计详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        <div class="titlelist" v-if="list.projectInfo"><div class="icons"></div>基本信息</div>
		<div class="listout" v-if="list.projectInfo">
			<div class="list">
				<div class="listleft">方案名称：{{list.projectInfo.projectName}}</div>
			</div>
			<div class="list">
				<div class="listleft">地址：{{list.projectInfo.provinceCode}}{{list.projectInfo.cityCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">联系人：{{list.projectInfo.linkman}}</div>
			</div>
			<div class="list">
				<div class="listleft">手机号：{{list.projectInfo.mobile}}</div>
			</div>
			
			
		</div>
		
		
		<div class="titlelist" v-if="list.projectOverview"><div class="icons"></div>项目概况</div>
		<div class="listout" v-if="list.projectOverview">
			<div class="list">
				<div class="listleft">所属区县：{{list.projectOverview.county}}</div>
			</div>
			<div class="list">
				<div class="listleft">室外计算温度：{{list.projectOverview.outdoorTemp}}</div>
			</div>
			<div class="list">
				<div class="listleft">极端最低温度：{{list.projectOverview.extremeMinTemp}}</div>
			</div>
			<div class="list">
				<div class="listleft">建筑需求：{{list.projectOverview.mobile}}</div>
			</div>
			
		</div>
		
		<div class="listout" v-if="list.projectOverview">
			<div class="list">
				<div class="listleft">建筑类型：{{list.projectOverview.typeCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">建筑面积：{{list.projectOverview.area}}</div>
			</div>
			<div class="list">
				<div class="listleft">保温情况：{{list.projectOverview.keepWarnCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">室内末端：{{list.projectOverview.indoorTail}}</div>
			</div>
			
		</div>
		
		<div class="listout" v-if="list.projectOverview">
			<div class="list">
				<div class="listleft">电价：{{list.projectOverview.electricityPrice}}</div>
			</div>
			<div class="list">
				<div class="listleft">夏季室内设：{{list.projectOverview.summerIndoorTemp}}</div>
			</div>
			<div class="list">
				<div class="listleft">冬季室内设：{{list.projectOverview.winterIndoorTemp}}</div>
			</div>
			<div class="list">
				<div class="listleft">采暖周期：{{list.projectOverview.heatCycle}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.projectOverview">
			<div class="list">
				<div class="listleft">制冷周期：{{list.projectOverview.coldCycle}}</div>
			</div>
			
		</div>
		
		
		<div class="titlelist" v-if="list.heatLoading"><div class="icons"></div>采暖负荷</div>
		<div class="listout" v-if="list.heatLoading">
			<div class="list">
				<div class="listleft">建筑面积：{{list.heatLoading.area}}</div>
			</div>
			<div class="list">
				<div class="listleft">指标值：{{list.heatLoading.indicator}}</div>
			</div>
			<div class="list">
				<div class="listleft">负荷值：{{list.heatLoading.loadingValue}}</div>
			</div>
			
		</div>
		
		<div class="titlelist" v-if="list.coldLoading"><div class="icons"></div>制冷负荷</div>
		<div class="listout" v-if="list.coldLoading">
			<div class="list">
				<div class="listleft">建筑面积：{{list.coldLoading.area}}</div>
			</div>
			<div class="list">
				<div class="listleft">指标值：{{list.coldLoading.indicator}}</div>
			</div>
			<div class="list">
				<div class="listleft">负荷值：{{list.coldLoading.loadingValue}}</div>
			</div>
			
		</div>
		
		
		<div class="titlelist" v-if="list.deviceInfo"><div class="icons"></div>空气源热泵</div>
		<div class="listout" v-if="list.deviceInfo">
			<div class="list">
				<div class="listleft">设备编码：{{list.deviceInfo.deviceCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">设备名称：{{list.deviceInfo.deviceName}}</div>
			</div>
			<div class="list">
				<div class="listleft">型号编码：{{list.deviceInfo.productSeriesCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">型号名称：{{list.deviceInfo.productSeriesName}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.deviceInfo">
			<div class="list">
				<div class="listleft">机组数量：{{list.deviceInfo.productNum}}</div>
			</div>
			<div class="list">
				<div class="listleft">总用电：{{list.deviceInfo.totalElectricity}}</div>
			</div>
			<div class="list">
				<div class="listleft">电力增容：{{list.deviceInfo.increaseElectricPower}}</div>
			</div>
			
		</div>
		
		
		<div class="titlelist" v-if="list.familyHeatColdDto"><div class="icons"></div>家用冷暖</div>
		<div class="listout" v-if="list.familyHeatColdDto">
			<div class="list">
				<div class="listleft">配电功率：{{list.familyHeatColdDto.distributionPower}}</div>
			</div>
			<div class="list">
				<div class="listleft">项目预算：{{list.familyHeatColdDto.productBudget}}</div>
			</div>
			<div class="list">
				<div class="listleft">户型：{{list.familyHeatColdDto.houseTypeCode}}</div>
			</div>
			
		</div>
		
		
		<div class="titlelist" v-if="list.benefitAnalysis"><div class="icons"></div>效益分析</div>
		<div class="listout" v-if="list.benefitAnalysis">
			<div class="list">
				<div class="listleft">建筑面积：{{list.benefitAnalysis.area}}</div>
			</div>
			<div class="list">
				<div class="listleft">项目初投资：{{list.benefitAnalysis.projectInvestment}}</div>
			</div>
			<div class="list">
				<div class="listleft">采暖运行费：{{list.benefitAnalysis.heatRunCost}}</div>
			</div>
			<div class="list">
				<div class="listleft">制冷运行费：{{list.benefitAnalysis.coldRunCost}}</div>
			</div>
			
		</div>
		
		<div class="listout" v-if="list.benefitAnalysis">
			<div class="list">
				<div class="listleft">单位面积采暖：{{list.benefitAnalysis.heatingCost}}</div>
			</div>
			<div class="list">
				<div class="listleft">单位面积制冷：{{list.benefitAnalysis.coldCost}}</div>
			</div>
			
		</div>
		
		<div class="titlelist" v-if="list.commercialHotWater"><div class="icons"></div>商用热水</div>
		<div class="listout" v-if="list.commercialHotWater">
			<div class="list">
				<div class="listleft">年度供暖成本：{{list.commercialHotWater.annualHeatingCost}}</div>
			</div>
			<div class="list">
				<div class="listleft">冷水温度：{{list.commercialHotWater.coldWaterTemp}}</div>
			</div>
			<div class="list">
				<div class="listleft">日需热量：{{list.commercialHotWater.dailyHeat}}</div>
			</div>
			<div class="list">
				<div class="listleft">日需热水用量：{{list.commercialHotWater.dailyHotWater}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.commercialHotWater">
			<div class="list">
				<div class="listleft">综合能效比：{{list.commercialHotWater.efficiencyRatio}}</div>
			</div>
			<div class="list">
				<div class="listleft">主机型号：{{list.commercialHotWater.hostModel}}</div>
			</div>
			<div class="list">
				<div class="listleft">每吨加热成本：{{list.commercialHotWater.perTonHeatingCost}}</div>
			</div>
			<div class="list">
				<div class="listleft">用水定额：{{list.commercialHotWater.waterQuota}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.commercialHotWater">
			<div class="list">
				<div class="listleft">冬季加热时间：{{list.commercialHotWater.winterHeatingTime}}</div>
			</div>
			
		</div>
		
		<div class="titlelist" v-if="list.schema1"><div class="icons"></div>方案1</div>
		<div class="listout" v-if="list.schema1">
			<div class="list">
				<div class="listleft">设备编码：{{list.schema1.deviceCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">设备名称：{{list.schema1.deviceName}}</div>
			</div>
			<div class="list">
				<div class="listleft">增加电力：{{list.schema1.increaseElectricPower}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品编号：{{list.schema1.productNum}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.schema1">
			<div class="list">
				<div class="listleft">产品系列编码：{{list.schema1.productSeriesCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品系列名称：{{list.schema1.productSeriesName}}</div>
			</div>
			<div class="list">
				<div class="listleft">总电量：{{list.schema1.totalElectricity}}</div>
			</div>
			
		</div>
		
		<div class="titlelist" v-if="list.schema2"><div class="icons"></div>方案2</div>
		<div class="listout" v-if="list.schema2">
			<div class="list">
				<div class="listleft">设备编码：{{list.schema2.deviceCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">设备名称：{{list.schema2.deviceName}}</div>
			</div>
			<div class="list">
				<div class="listleft">增加电力：{{list.schema2.increaseElectricPower}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品编号：{{list.schema2.productNum}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.schema2">
			<div class="list">
				<div class="listleft">产品系列编码：{{list.schema2.productSeriesCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品系列名称：{{list.schema2.productSeriesName}}</div>
			</div>
			<div class="list">
				<div class="listleft">总电量：{{list.schema2.totalElectricity}}</div>
			</div>
			
		</div>
		
		<div class="titlelist" v-if="list.schema3"><div class="icons"></div>方案3</div>
		<div class="listout" v-if="list.schema3">
			<div class="list">
				<div class="listleft">设备编码：{{list.schema3.deviceCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">设备名称：{{list.schema3.deviceName}}</div>
			</div>
			<div class="list">
				<div class="listleft">增加电力：{{list.schema3.increaseElectricPower}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品编号：{{list.schema3.productNum}}</div>
			</div>
			
		</div>
		<div class="listout" v-if="list.schema3">
			<div class="list">
				<div class="listleft">产品系列编码：{{list.schema3.productSeriesCode}}</div>
			</div>
			<div class="list">
				<div class="listleft">产品系列名称：{{list.schema3.productSeriesName}}</div>
			</div>
			<div class="list">
				<div class="listleft">总电量：{{list.schema3.totalElectricity}}</div>
			</div>
			
		</div>
		
		
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getsigndwebetail
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:[],
		  resultFilelist:[],
		  lists:[],
		  fileList: [],
		  tabPosition:'',
		  id:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.tabPosition = this.$route.query.tabPosition
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getsigndwebetail(this.tabPosition,this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
				 //  this.resultFilelist = []
				 // console.log(888889,this.resultFilelist)
				 // if(res.data.pictureInfoList){
					//  res.data.pictureInfoList.map((item,index)=>{
					//      this.resultFilelist.push({
					//        url:item.fileTemporaryUrl,
					//        fileTemporaryUrl:item.fileTemporaryUrl,
					//        fileId:item.fileId,
					//        name: item.ossFile.fileName,
					//        mediaObjInfo:item
					//      })
					     
					//  })
				 // }
				 
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/scheme'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.lists{
		width: 40%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tableout{
	  width: 95%;
	  height: 120px;
	  border: 1px solid #d9d9d9;
	  border-radius: 5px;
	  font-size: 14px;
  }
  .tablelist{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  
  }
  .tablelists{
  	  width: 100%;
  	  height: 40px;
  	  line-height: 40px;
  	  text-align: center;
  	  display: flex;
  	  
  }
  .tabletitle{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  display: flex;
	  background-color: #ebe8e8;
  }
  .tabileleft{
	  width: 50%;
	  text-align: center;
	  
  }
  .tabileright{
	  width: 50%;
	  text-align: center;
  }
  .liststable{
  	width: 25%;
  }
  .listouts{
  	width: 96%;
  	display: flex;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .imglist img{
	  width: 100px;
	  height: 100px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/guidetool/schemeadd.vue